import oGet from 'lodash/get'
import uniqBy from 'lodash/uniqBy'
import { get, post } from './base'

const faxlogApi = {
  Ename: {
    delete: 'delete',
    star: 'star',
    read: 'read',
  },

  // 更新fax记录
  faxlogUpdate({ ids, name, value }) {
    // 对 ids 批量更新 name 值为 value
    // 例子： 对 [3552,3211] 两个数据 更新  delete  值为 1 （表示删除3552 3211两条记录）
    // 例子2： 对 [3552,3211] 两个数据 更新  read  值为 1 （表示3552 3211两条记录 已读）
    return post('api/payload/faxlog/bulk-update', {
      ids,
      name,
      value,
    })
  },
  // 删除至垃圾箱
  faxlogDelete(ids) {
    return faxlogApi.faxlogUpdate({
      ids,
      name: faxlogApi.Ename.delete,
      value: 1,
    })
  },
  // 从垃圾箱 恢复 （取消删除）
  faxlogUnDelete(ids) {
    return faxlogApi.faxlogUpdate({
      ids,
      name: faxlogApi.Ename.delete,
      value: 0,
    })
  },
  // 从垃圾箱删除 （永久删除）
  faxlogDeleteForever(ids) {
    return faxlogApi.faxlogUpdate({
      ids,
      name: faxlogApi.Ename.delete,
      value: 2,
    })
  },
  // 收藏
  faxlogStar(ids) {
    return faxlogApi.faxlogUpdate({
      ids,
      name: faxlogApi.Ename.star,
      value: 1,
    })
  },
  // 取消收藏
  faxlogUnStar(ids) {
    return faxlogApi.faxlogUpdate({
      ids,
      name: faxlogApi.Ename.star,
      value: 0,
    })
  },
  // 已读
  faxlogRead(ids) {
    return faxlogApi.faxlogUpdate({
      ids,
      name: faxlogApi.Ename.read,
      value: 1,
    })
  },
  // 取消已读
  // faxlogUnRead() {},
}

const payLoadApi = {
  ...faxlogApi,
  getSentbox(page, size = 12, params = {}) {
    return get('api/payload/fax/sentbox_web', {
      page,
      size,
      ...params,
    })
  },
  getInbox(page, size = 12, params = {}) {
    return get('api/payload/fax/inbox_web', {
      page,
      size,
      ...params,
    })
  },
  getOutbox(page, size = 12, params = {}) {
    return get('api/payload/fax/outbox_web', {
      page,
      size,
      ...params,
    })
  },
  getTrash(page, size = 12, params = {}) {
    return get('api/payload/fax/deletedfax_web', {
      page,
      size,
      ...params,
    })
  },
  getDarftbox(page, size = 12, params = {}) {
    return get('api/payload/fax/draftbox_web', {
      page,
      size,
      ...params,
    })
  },
  getStarbox(page, size = 12, params = {}) {
    return get('api/payload/fax/starbox_web', {
      page,
      size,
      ...params,
    })
  },

  ContactsTemp: [],

  getContacts({ page = 0, size = 100, direction = '', orderBy = '', query = '' }) {
    return get('api/payload/contacts_web', {
      page,
      size,
      query,
      direction, // 枚举 ASC ,DESC,ASC是升序，DESC是降序
      orderBy, // dateModified,contactName,phoneNumber；分别对应的是更新日期，联系人名，号码排序
    }).then((data) => {
      const list = oGet(data, 'content', [])
      const newList = [...list, ...payLoadApi.ContactsTemp]
      const rsList = uniqBy(newList, (item) => {
        return oGet(item, 'phoneNumber', '')
      })
      payLoadApi.ContactsTemp = rsList
      return data
    })
  },

  getContactByPhoneNumber(phoneNumber) {
    for (let i = 0; i < payLoadApi.ContactsTemp.length; i++) {
      if (oGet(payLoadApi.ContactsTemp, `${i}.phoneNumber`) === phoneNumber) {
        return Promise.resolve(oGet(payLoadApi.ContactsTemp, `${i}`, null))
      }
    }
    return Promise.resolve(null)
  },

  getFaxUsage() {
    return get('api/payload/faxUsage')
  },

  deleteContacts(ids) {
    return post('api/payload/contacts/bulk-delete', { ids })
  },

  updateContacts(contacts = []) {
    return post('api/payload/contacts/addorupdate', contacts)
  },

  addOrUpdateContacts(contacts = []) {
    return post('api/payload/contacts/addorupdate', contacts)
  },

  //分组联系人列表
  contactsByGroup() {
    return get('api/payload/contactsByGroup')
  },

  //组名列表
  listGroups() {
    return get('api/payload/contacts/groups')
  },
}

export default payLoadApi
